export default "__VITE_ASSET__059a1759__"